import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {BehaviorSubject, map, Observable} from "rxjs";
import {LocalStorageService, ResponseHttpSuccess,CustomMessageService, UtilService} from "library";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {environment} from "projects/store/src/environments/environment";
import {KYCResponse} from "projects/store/src/app/interfaces";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {Router} from '@angular/router';
import {Location} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url: string = environment.apiURL;
  salesUrl: string = environment.salesAPIURL;
  authentication: Observable<boolean>;
  authenticationSubject: BehaviorSubject<boolean>;

  constructor(private localStorageService: LocalStorageService,
              private http: HttpClient,
              private router: Router,
              private location: Location,
              private pathNavigationService: PathNavigationService) {
    this.authenticationSubject = new BehaviorSubject<boolean>(false);
    this.authentication = this.authenticationSubject.asObservable();
  }

  gotoSalesModule(path: string) {
    let url: string = '';
    if( ! ["recuperar-clave", "auth/logout"].includes(path)) {
      const token = this.localStorageService.get(LocalStorageKey.salesModuleToken);
      url = `${environment.salesSiteURL}auth/login?returnUrl=${encodeURIComponent(path)}&token=${token}`;
    }else{
      url = `${environment.salesSiteURL}${path}`;
    }
    window.location.href = url;
  }

  getHttpOptionsBearer(): {}{
    let salesToken = this.localStorageService.get(LocalStorageKey.salesToken);
    let token = this.localStorageService.get(LocalStorageKey.token);
    if (typeof salesToken == 'string' || typeof token == 'string') {
      return this.getHttpOptions(salesToken ? salesToken : undefined, token ? token : undefined);
    }
    const match = this.location.path().match(/ventas\/([^\/]+)/);
    const flowCode = match ? match[1] : '';
    this.pathNavigationService.navigateToInvalidSession(flowCode)
    throw new Error('Token no válido');
  }

  private getHttpOptions(salesToken?: string, token?: string): {} {
    let headersHTTP: Record<string, string>;
    if(typeof salesToken === 'undefined' && typeof token === 'undefined') {
      headersHTTP = { 'Content-Type': 'application/json' };
    }else{
      headersHTTP = {
        'Content-Type': 'application/json'
      };

      if (salesToken !== undefined) {
        headersHTTP['X-SALES-TOKEN'] = salesToken;
      }

      if (token !== undefined) {
        headersHTTP['Authorization'] = `Bearer ${token}`;
      }

    }
    return {
      headers: new HttpHeaders(headersHTTP),
      observe: 'response'
    };
  }

  isAuthenticated() {
    let token = this.localStorageService.get(LocalStorageKey.token);
    let data = this.localStorageService.get(LocalStorageKey.data);
    return typeof token == 'string' && token.length >= 200 && data?.user !== undefined && data?.store !== undefined;
  }

  checkCredential(data: { email: string, password: string}) {
    return this.http.post(`${this.url}auth/check-credentials`, data, this.getHttpOptions())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }

  checkStatus(userId: string) {
    return this.http.get(`${this.url}auth/user/${userId}/check-status`, this.getHttpOptions())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }

  confirmUserInformation(userId: string) {
    const data = { confirm: true };
    return this.http.put(`${this.url}auth/user/${userId}/confirm-information`, data, this.getHttpOptions())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }

  saveKYCResponse(userId: string, data: KYCResponse) {
    return this.http.post(`${this.url}auth/user/${userId}/kyc-response`, data, this.getHttpOptions())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }

  login(data: { email: string, password: string }) {
    return this.http.post(`${this.url}auth/sign-in`, data, this.getHttpOptions())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }

  logout() {
    return this.http.delete(`${this.url}auth/sign-out`, this.getHttpOptions())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }

  authenticationNext(status: boolean) {
    if(status == false) {
      this.localStorageService.remove(LocalStorageKey.salesToken);
    }
    this.authenticationSubject.next(status);
  }

  getToken(data: { store_id: string, source: string, current_token: string}) {
    return this.http.post(`${this.salesUrl}token`, data, this.getHttpOptions())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }
}
